import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type CartPreferencesState = {
  recentCartId: string | null;
  recentRfqId: string | null;
};

const initialState: CartPreferencesState = {
  recentCartId: null,
  recentRfqId: null,
};

const cartPreferences = createSlice({
  name: 'cartPreferences',
  initialState,
  reducers: {
    setRecentCartId(state, action: PayloadAction<string | null>) {
      state.recentCartId = action.payload;
    },
    setRecentRfqId(state, action: PayloadAction<string | null>) {
      state.recentRfqId = action.payload;
    },
  },
});

export const { setRecentCartId, setRecentRfqId } = cartPreferences.actions;

export default cartPreferences.reducer;
